import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    style: !_vm.isEditable ? 'opacity: 0.9' : '',
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', _vm._g({
    attrs: {
      "headline": _vm.computeFunctionStringParam(_vm.headline, _vm.originalItem),
      "subtitle": _vm.computeFunctionStringParam(_vm.subtitle, _vm.originalItem),
      "buttons": _vm.computedHeaderButtons,
      "itemIsChanged": _vm.itemIsChanged,
      "templateContext": !_vm.isEmpty(_vm.templateInformation),
      "hasUnsyncedChanges": !_vm.isEmpty(_vm.templateInformation) && _vm.templateInformation.hasUnsyncedChanges
    },
    scopedSlots: _vm._u([{
      key: "buttons-after",
      fn: function () {
        return [_vm._t("buttons-after"), _vm.editMode ? _c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('Core.DetailsPage.header.buttons.save.label'),
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.itemIsChanged || !_vm.formIsValid,
            "tooltip": !_vm.itemIsChanged ? _vm.$i18n_t('Core.DetailsPage.header.buttons.save.tooltip.disabled.noChanges') : '',
            "loading": _vm.isSaving,
            "data-cy": "details-page-save-button"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.onSaveClick.apply(null, arguments);
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Core.DetailsPage.header.buttons.save.label')) + "\n      ")]) : _vm._e(), _vm.parentHref ? _c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('Core.DetailsPage.header.buttons.close'),
            "color": "danger",
            "prepend-icon": "fa-times",
            "data-cy": "details-page-close-button"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return (() => _vm.onCloseClick()).apply(null, arguments);
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "subtitle-slot",
      fn: function () {
        return [_vm._t("subtitle-slot"), !_vm.isEmpty(_vm.templateInformation) ? _c('div', {
          staticClass: "flex-container"
        }, [_c(VChip, {
          staticClass: "ma-1",
          attrs: {
            "color": _vm.getStatus(_vm.synchronisationStatus, _vm.linkedDevicesTotalCountSafe).color,
            "dark": ""
          }
        }, [_vm._v("\n          " + _vm._s(_vm.getStatus(_vm.synchronisationStatus, _vm.linkedDevicesTotalCountSafe).text) + "\n        ")]), _vm._v("\n         \n        "), _vm.editMode ? _c(VSwitch, {
          staticStyle: {
            "margin": "5px 0 5px 10px",
            "opacity": "0.7",
            "padding": "2px 0"
          },
          attrs: {
            "color": _vm.color,
            "label": _vm.switchLabel,
            "input-value": false,
            "hide-details": "",
            "inset": ""
          },
          model: {
            value: _vm.showDraftVersion,
            callback: function ($$v) {
              _vm.showDraftVersion = $$v;
            },
            expression: "showDraftVersion"
          }
        }) : _vm._e()], 1) : _vm._e()];
      },
      proxy: true
    }], null, true)
  }, _vm.$listeners)), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('Core.DetailsPage.prompts.unsaved.title'),
      "open": _vm.showUnsavedPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Core.DetailsPage.prompts.unsaved.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Core.DetailsPage.prompts.unsaved.discard'),
        color: 'error',
        emit: 'discard-and-close'
      }, {
        text: _vm.$i18n_t('Core.DetailsPage.prompts.unsaved.close'),
        emit: 'close-page'
      }]
    },
    on: {
      "cancel": () => _vm.onUnsavedChangesDialogButton('cancel'),
      "discard-and-close": () => _vm.onUnsavedChangesDialogButton('discard-and-close'),
      "close-page": () => _vm.onUnsavedChangesDialogButton('close-page')
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Core.DetailsPage.prompts.unsaved.text')) + "\n  ")]), _vm.fetchError ? _c(VAlert, {
    staticClass: "ml-4 mr-4 mt-2",
    attrs: {
      "prominent": "",
      "type": "error"
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "grow"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Core.DetailsPage.alerts.fetchError.title')) + "\n        "), _c('br'), _c('i', [_vm._v(_vm._s(_vm.$i18n_t(`Error.${_vm.fetchError.translationKey}`, _vm.fetchError.details)))])]), _c(VCol, {
    staticClass: "shrink"
  }, [_c(VBtn, {
    attrs: {
      "loading": _vm.isFetching
    },
    on: {
      "click": _vm.callFetchItem
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Core.DetailsPage.alerts.fetchError.refetchBtn')) + "\n        ")])], 1)], 1)], 1) : _vm._e(), _c(VForm, {
    ref: "form",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "submit": e => e.preventDefault()
    },
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VCard, {
    staticClass: "mb-8"
  }, [_c(VCardText, [_c(VTabs, {
    class: {
      sm: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _vm._l(_vm.computedTabs, function (tab) {
    return _c(VTab, {
      key: tab.urlHashbang,
      attrs: {
        "href": `#${tab.urlHashbang}`
      }
    }, [_c('span', {
      attrs: {
        "data-cy": `details-page-tab-${tab.urlHashbang}`
      }
    }, [_vm._v("\n                  " + _vm._s(tab.label) + "\n                ")])]);
  }), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, _vm._l(_vm.computedTabs, function (tab) {
    return _c(VTabItem, {
      key: tab.urlHashbang,
      attrs: {
        "value": tab.urlHashbang,
        "color": "danger",
        "eager": tab.eager
      }
    }, _vm._l(tab.rows, function (row, rowIndex) {
      return _c(row.isExpansionPanel ? 'v-expansion-panels' : 'div', {
        key: `row_${rowIndex}`,
        tag: "component",
        class: 'ml-1 mr-1 ' + row.class + ' ' + (row.isExpansionPanel ? 'mt-6 mb-6 pl-4 pr-4' : '')
      }, [_c(row.isExpansionPanel ? 'v-expansion-panel' : 'div', {
        tag: "component"
      }, [row.isDivider ? _c(VDivider, {
        staticClass: "mt-8 mb-8"
      }) : _vm._e(), row.headline || row.headlineHTML || row.subtitle || row.subtitleHTML ? _c(row.isExpansionPanel ? 'v-expansion-panel-header' : 'v-row', {
        tag: "component"
      }, [_c(VCol, {
        attrs: {
          "col": "12"
        }
      }, [!!(row.headline || row.headlineHTML) ? _c('h5', {
        staticStyle: {
          "background-color": "unset !important"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.computeFunctionStringParam(row.headline, _vm.item))
        }
      }) : _vm._e(), row.subtitle || row.subtitleHTML ? _c('div', {
        staticClass: "card-description",
        staticStyle: {
          "max-width": "65vw",
          "background-color": "unset !important"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.computeFunctionStringParam(row.subtitle, _vm.item))
        }
      }) : _vm._e()])], 1) : _vm._e(), _c(row.isExpansionPanel ? 'v-expansion-panel-content' : 'v-row', {
        tag: "component"
      }, _vm._l(row.columns, function (column, columnIndex) {
        return _c(column.isSpacer ? 'v-spacer' : 'v-col', {
          key: 'column_' + columnIndex,
          tag: "component",
          class: column.class,
          attrs: {
            "cols": column.cols,
            "sm": column.sm,
            "md": column.md,
            "lg": column.lg
          }
        }, [Array.isArray(column.rows) ? _vm._l(column.rows, function (subRow, subRowIndex) {
          return _c(VRow, {
            key: 'subRow_' + subRowIndex,
            class: subRow.class
          }, [subRow.isDivider ? _c(VDivider) : _vm._e(), _vm._l(subRow.columns, function (subColumn, subColumnIndex) {
            return _c(subColumn.isSpacer ? 'v-spacer' : 'v-col', {
              key: 'subColumn_' + subColumnIndex,
              tag: "component",
              class: subColumn.class,
              attrs: {
                "cols": subColumn.cols,
                "sm": subColumn.sm,
                "md": subColumn.md,
                "lg": subColumn.lg
              }
            }, [subColumn.slotName ? _vm._t(subColumn.slotName, null, {
              "item": _vm.item,
              "editMode": _vm.isEditable,
              "originalItem": _vm.originalItem,
              "field": subColumn.field,
              "emitInput": value => _vm.updateItemByFieldKey(subColumn.field.key, value),
              "updateFieldByKey": updater => updater(_vm.updateItemByFieldKey, _vm.item)
            }) : subColumn.field ? _c('core-details-page-field', {
              attrs: {
                "field": subColumn.field,
                "item": _vm.item,
                "original-item": _vm.originalItem,
                "edit-mode": _vm.isEditable,
                "isProductiveVersion": !_vm.isEmpty(_vm.templateInformation) && _vm.templateInformation.isProductiveVersion,
                "update-item-by-field-key": _vm.updateItemByFieldKey
              },
              on: {
                "input": value => _vm.updateItemByFieldKey(subColumn.field.key, value)
              }
            }) : _vm._e()], 2);
          })], 2);
        }) : [column.slotName ? _vm._t(column.slotName, null, {
          "item": _vm.item,
          "editMode": _vm.isEditable,
          "originalItem": _vm.originalItem,
          "field": column.field,
          "emitInput": value => _vm.updateItemByFieldKey(column.field.key, value),
          "updateFieldByKey": updater => updater(_vm.updateItemByFieldKey, _vm.item)
        }) : column.field ? _c('core-details-page-field', {
          attrs: {
            "field": column.field,
            "item": _vm.item,
            "original-item": _vm.originalItem,
            "edit-mode": _vm.isEditable,
            "isProductiveVersion": !_vm.isEmpty(_vm.templateInformation) && _vm.templateInformation.productiveVersion,
            "update-item-by-field-key": _vm.updateItemByFieldKey
          },
          on: {
            "input": value => _vm.updateItemByFieldKey(column.field.key, value)
          }
        }) : _vm._e()]], 2);
      }), 1)], 1)], 1);
    }), 1);
  }), 1)], 2)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };